const iotRouters = {
  path: "/iot",
  component: () => import("@/views/layout"),
  name: "iot",
  meta: { public: true, theme: "none" },
  children: [
    {
      path: "device-log",
      component: () => import("@/views/IOT/DeviceLog"),
      name: "device-log"
    }
  ]
}

export default iotRouters
